
import { Component, Watch, Prop, VModel } from 'vue-property-decorator'
import { Debounce } from 'lodash-decorators'
import { Mixins } from 'vue-mixin-decorator'
import MixinInterface from '@/_mixins/index'
import ObservationMixin from '@/_mixins/observation'
import ContractorInfo from './contractorInfo.vue'
import DialogTemplate from '@/_components/dialog/template/template.vue'

@Component({
    mixins: [ObservationMixin],
    components: { ContractorInfo, DialogTemplate },
})
export default class ContractorPicker extends Mixins<MixinInterface>(ObservationMixin) {
    @VModel() filter!: Array<any>
    @Prop({ required: true }) projectId!: string
    @Prop({ default: true }) isWritable!: boolean
    @Prop({ default: false }) returnObject!: boolean
    @Prop({ default: false }) allowArchived!: boolean
    @Prop({ default: null }) color!: string | null
    @Prop({ default: false }) hasIsNull!: boolean

    contractorsDialog = false
    searchTerm = ''
    contractorHierarchiesNodes = [] as Array<any>

    localFilters = [] as Array<any>

    selectFilters() {
        if (this.isNullLocal) {
            this.filter = ['null']
        } else {
            this.filter = this.returnObject
                ? this.localFilters
                : this.localFilters.map((val) => val?.id)
        }

        this.contractorsDialog = false
    }

    removeContractor(contractorId: string) {
        this.localFilters = this.localFilters.filter((contractor) => contractor?.id != contractorId)
        this.selectFilters()
    }

    // IsNull (filter[contractors][isNull] and filter[contractors][contains] do not work together)
    isNullLocal = false

    //If user set isNull to true, FE has to empty the filters array
    toggleIsNull(val: boolean) {
        if (val) {
            this.localFilters = []
        }
    }

    // If user selects any of the items from treeview, isNull option is not valid anymore
    handleLocalFilters() {
        if (this.localFilters?.length > 0 && this.isNullLocal) {
            this.isNullLocal = false
        }
    }

    // Treeview
    contractorHierarchiesNodesTree = [] as Array<any>

    get contractorHierarchyByProject() {
        return this.$store.getters.contractorHierarchies[this.projectId]
    }

    @Watch('contractorsDialog')
    async setContractors() {
        if (this.projectId) {
            this.isNullLocal = this.filter.includes('null')

            if (!this.contractorHierarchyByProject) {
                await this.getContractorHierarchiesByProject(this.projectId).catch(() => {
                    //
                })
            }

            let contractorsNodes = this.contractorHierarchyByProject
                ? this.contractorHierarchyByProject.nodes.data
                : []
            contractorsNodes = contractorsNodes.filter((node) => !node.isArchived)
            contractorsNodes = contractorsNodes.map((node) => {
                return {
                    ...node,
                    ...(!this.allowArchived && { disabled: node.isArchived }),
                    type: 'contractor',
                    name: node.namePath[node.namePath.length - 1],
                }
            })

            this.contractorHierarchiesNodes = this.lodash.cloneDeep(contractorsNodes)

            this.contractorHierarchiesNodesTree = this.lodash.cloneDeep(
                this.unflattenArray(contractorsNodes, undefined)
            )

            if (this.contractorsDialog) {
                this.initOpenNodes()
            }
        }
    }

    @Watch('filter', { immediate: true })
    async setLocalFilter() {
        if (!this.contractorsDialog) {
            await this.setContractors()
            if (this.filter.includes('null')) {
                this.localFilters = this.lodash.cloneDeep(this.filter)
                return
            }
            this.localFilters = this.returnObject
                ? this.lodash.cloneDeep(this.filter)
                : this.lodash
                      .cloneDeep(this.filter)
                      .map((item) =>
                          this.contractorHierarchiesNodes.find(
                              (contractor) => contractor.id == item
                          )
                      )
        }
    }

    // Nodes control
    openNodes = [] as Array<any>

    initOpenNodes() {
        this.openNodes = []
        if (this.lodash.isArray(this.localFilters)) {
            this.localFilters.forEach((item) => {
                this.openNodesById(item?.id)
            })
        } else if (this.localFilters) {
            this.openNodesById(this.localFilters)
        }
    }

    openNodesById(id: string, firstLevel = true) {
        if (!id) return
        const item = this.contractorHierarchiesNodes.find((val) => val?.id == id)
        const parent = item.parent.data

        if (!firstLevel) {
            const hasNode = this.openNodes.findIndex((val) => val?.id == item?.id) > -1
            if (!hasNode) {
                this.openNodes.push(item)
            }
        }

        if (parent) {
            this.openNodesById(parent?.id, false)
        }
    }

    @Debounce(500)
    @Watch('searchTerm')
    openNodesByName() {
        this.openNodes = []

        if (!this.searchTerm) {
            this.initOpenNodes()
            return
        }

        const filterdItems = this.contractorHierarchiesNodes.filter((val) => {
            return val.name.toLowerCase().includes(this.searchTerm.toLowerCase())
        })

        filterdItems.forEach((item) => {
            this.openNodesById(item?.id)
        })
    }
}
